export default __webpack_public_path__ + "static/media/spin.0e9ff897.mp3";